module.exports = __webpack_public_path__ + "img/Bayomi.fe4851b9.jpeg";